import React from 'react'
import PropTypes from 'prop-types'
import { Container, Col, Row } from 'reactstrap'
import { BarLoader } from 'react-spinners'
import payPalLogo from '../../assets/icons/PayPal.svg'
import PaypalService from '../../api/services/PaypalService'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import * as actions from '../../actions/cart'
import * as actionsCheckout from '../../actions/checkout'
import { FormattedMessage, injectIntl } from 'react-intl'
import EventsTracker from '../../helpers/eventsTracker'
import {
  DoneIcon,
  ErrorIcon,
  CircleLine,
  Header,
  LoadingBox,
  PaymentProgress,
  DescriptionText,
  LoadingBoxHeader,
  LoadingBoxLoader,
  HeaderText
} from './OrderStatusStyledComponents'

const eventsTracker = new EventsTracker()

class OrderStatus extends React.PureComponent {
  static propTypes = {
    checkout: PropTypes.object,
    intl: PropTypes.object.isRequired,
    cart: PropTypes.object,
    actionsCheckout: PropTypes.object,
    actions: PropTypes.object,
    activeStore: PropTypes.object,
    history: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      paymentApproved: false,
      statusText: null,
      headerText: null,
      descriptionText: null,
      statusBadgeText: null,
      paymentStatus: 0
    }
  }

  componentDidMount() {
    if (this.props.checkout.paymentCanceled) {
      this.onOrderCanceled()
    } else {
      // donno why this timeout is there need to investigate, left is as until not ensure
      this.timeout = setTimeout(() => {
        this.getPaymentStatus()
      }, 5000)
    }
  }

  onOrderCanceled() {
    this.setState({ loading: true })
    this.setPaymentCancel()
  }

  async getPaymentStatus() {
    const { orderID, PayerID } = this.props.checkout.orderData
    const { intl, actionsCheckout } = this.props
    try {
      try {
        eventsTracker.checkoutSuccess(this.props.cart)
      } catch (e) {
        console.log('Error while login event in eventsTracker', e)
      }
      await PaypalService.checkoutOrdersPay(orderID, PayerID)

      this.props.actions.clearCart()
      this.setState({
        loading: true,
        paymentApproved: true,
        statusText: intl.formatMessage({ id: 'order.statusSuccess' }),
        headerText: intl.formatMessage({ id: 'order.successOrderHeader' }),
        descriptionText: intl.formatMessage({
          id: 'order.successOrderDescription'
        }),
        statusBadgeText: intl.formatMessage({ id: 'order.statusSuccessBadge' })
      })
    } catch (e) {
      let error
      try {
        error = JSON.parse(e)
      } catch (SyntaxError) {
        error = e
      }
      if (error && error.graphQLErrors) {
        if (error.graphQLErrors.find(ref => ref.extensions.code === 'instrument_declined')) {
          actionsCheckout.setPaymentStatus('error', {}, 'paypal_error', this.props.activeStore.getShortId(), {
            type: 'INSTRUMENT_DECLINED'
          })
        }
        if (error.graphQLErrors.find(ref => ref.extensions.code === 'payer_cannot_pay')) {
          actionsCheckout.setPaymentStatus('error', {}, 'paypal_error', this.props.activeStore.getShortId(), {
            type: 'PAYER_CANNOT_PAY'
          })
        }
      }

      this.setState({
        loading: true,
        paymentApproved: false,
        statusText: intl.formatMessage({ id: 'order.statusUnsuccessful' }),
        headerText: intl.formatMessage({ id: 'order.unsuccessfulOrderHeader' }),
        statusBadgeText: intl.formatMessage({
          id: 'order.statusUnsuccessfulBadge'
        })
      })
    }
  }

  async setPaymentCancel() {
    const { paymentToken } = this.props.checkout.orderData
    const { intl } = this.props
    this.setState({
      statusText: intl.formatMessage({ id: 'order.statusCanceled' }),
      headerText: intl.formatMessage({ id: 'order.canceledOrderHeader' }),
      statusBadgeText: intl.formatMessage({ id: 'order.statusCanceledBadge' }),
      paymentApproved: false
    })
    try {
      await PaypalService.setPaymentCancel(paymentToken)
    } catch (e) {
      console.error(e)
    }
  }

  backToHome = () => {
    this.props.history.push(`/home`)
  }

  backToStore = () => {
    // this.props.history.push(`/store/${this.props.activeStore.shortId}`)
    this.props.toggle()
  }

  render() {
    const { loading, paymentApproved, statusText, headerText, descriptionText, statusBadgeText } = this.state

    return (
      <Container className="order-status mt-5">
        {loading && (
          <Row className="justify-content-center">
            <Col md="10" className="text-center">
              <Header paymentApproved={paymentApproved}>
                <FormattedMessage id="order.order" /> {statusText}
              </Header>

              <HeaderText>{headerText}</HeaderText>
              <DescriptionText>{descriptionText}</DescriptionText>
            </Col>
            <PaymentProgress sm="10">
              <Row>
                <Col xs={{ size: 4 }} className="circle-box">
                  <DoneIcon />
                  <p className="mt-5 mb-5">
                    <FormattedMessage id="order.checkout" />
                  </p>
                  <CircleLine color="green" />
                </Col>
                <Col xs={{ size: 4 }} className="circle-box">
                  <DoneIcon />
                  <p className="mt-5 mb-5">
                    <FormattedMessage id="order.payment" />
                  </p>
                  {paymentApproved && <CircleLine color="green" />}
                  {!paymentApproved && <CircleLine color="red" />}
                </Col>
                <Col xs={{ size: 4 }} className="circle-box">
                  {!paymentApproved && <ErrorIcon />}
                  {paymentApproved && <DoneIcon />}
                  <p className="mt-5 mb-5">
                    <FormattedMessage id="order.payment" />
                    {` ${statusBadgeText}`}
                  </p>
                </Col>
              </Row>
            </PaymentProgress>
            <Col md="10" className="text-center">
              <p>
                <FormattedMessage id="order.paymentsSupported" />
              </p>
            </Col>
            <Col md="4" className="text-center">
              <img className="img-fluid" src={payPalLogo} alt="HausMart" />
            </Col>
          </Row>
        )}

        {!loading && (
          <LoadingBox>
            <LoadingBoxHeader>
              <FormattedMessage id="order.processing" />
            </LoadingBoxHeader>
            <h4>
              <FormattedMessage id="order.wait" />
            </h4>
            <LoadingBoxLoader>
              <BarLoader color={'#DDC16B'} loading={!loading} width={170} height={8} />
            </LoadingBoxLoader>

            <p>
              <FormattedMessage id="order.paymentsSupported" />
            </p>
            <img className="img-fluid" src={payPalLogo} alt="HausMart" />
          </LoadingBox>
        )}
      </Container>
    )
  }
}

OrderStatus.propTypes = {
  toggle: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    activeStore: state.activeStore,
    checkout: state.checkout
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  actionsCheckout: bindActionCreators(actionsCheckout, dispatch)
})

export default compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(OrderStatus)

export { OrderStatus }
